module.exports = __webpack_public_path__ + "static/media/paypal-logo.73f85087.svg";